import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "col-sm-3" }
const _hoisted_12 = { class: "col-sm-3" }
const _hoisted_13 = { class: "col-sm-3" }
const _hoisted_14 = { class: "col-sm-3" }
const _hoisted_15 = { class: "text-center mt-5" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Override Water Footprint Default Configuration",
          text: "Override Water Footprint Default Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Garment",
              labelValue: "Garment",
              placeholderKey: "Garment",
              placeholderValue: "Garment",
              list: _ctx.garmentIds,
              modelValue: _ctx.localSelectedGarmentId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localSelectedGarmentId) = $event)),
              onChange: _ctx.updateGarmentForEachWaterFootprintValue
            }, null, 8, ["list", "modelValue", "onChange"])
          ])
        ]),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localWaterFootprintList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row align-items-center mb-2",
            key: index
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(item.productionPhase.text), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Green water (ml/g)",
                labelValue: "Green water (ml/g)",
                placeholderKey: "Green water (ml/g)",
                placeholderValue: "Green water (ml/g)",
                modelValue: item.greenWater,
                "onUpdate:modelValue": ($event: any) => ((item.greenWater) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Blue water (ml/g)",
                labelValue: "Blue water (ml/g)",
                placeholderKey: "Blue water (ml/g)",
                placeholderValue: "Blue water (ml/g)",
                modelValue: item.blueWater,
                "onUpdate:modelValue": ($event: any) => ((item.blueWater) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Grey water (ml/g)",
                labelValue: "Grey water (ml/g)",
                placeholderKey: "Grey water (ml/g)",
                placeholderValue: "Grey water (ml/g)",
                modelValue: item.greyWater,
                "onUpdate:modelValue": ($event: any) => ((item.greyWater) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Confirm",
            text: "Confirm"
          })
        ], 8, _hoisted_16)
      ])
    ])
  ]))
}